export const KEY_USER_STORAGE = '@jobs/user'
export const KEY_COMPANY_STORAGE = '@jobs/company'
export const HOTJAR_CLASSNAME = 'hj-application-success'
